'use client';

import React from 'react';

import { Media } from '@/components/Media';
import { ModalForm } from '@/components/ModalForm';
import { Svg } from '@ui/svg';
import { Button } from '@ui/button';
import type { Misc, FeaturesGlobalWidget } from '@/payload-types';

export const PsychiatristServicesCTA: React.FC<{
  title: string;
  features: FeaturesGlobalWidget['value'];
  misc: Misc;
}> = ({ title, features, misc }) => {
  const { phones } = misc.refs;

  return (
    <section className="my-[72px] md:my-10" data-name="PsychiatristServicesCTA">
      <div className="container">
        <div className="bg-blue corners overflow-hidde px-8 pt-[59px] pb-[72px] text-center text-white md:px-4 md:pt-[43px] md:pb-14">
          <div className="relative flex flex-col items-center">
            <h2 className="h2 mb-[29px] max-w-[700px] uppercase md:mb-5">
              {title}
            </h2>

            {features && (
              <div className="mb-12 flex flex-wrap justify-center gap-8 md:mb-8 lg:gap-5">
                {features.map((i) => (
                  <div className="flex items-center gap-2" key={i.id}>
                    <Media className="w-8 md:w-7" resource={i.image} />
                    <div className="h7">{i.title}</div>
                  </div>
                ))}
              </div>
            )}

            <div className="bg-blue flex h-12 w-fit items-center justify-between gap-3 rounded-full border sm:gap-2 md:mx-auto md:h-10 md:self-start">
              <div className="link-secondary flex items-center gap-2 p-[3px] md:gap-1">
                <div className="flex-center text-blue aspect-square w-10 rounded-full bg-gray-700 md:w-8">
                  <Svg className="md:w-3" id="phone" width="16" height="16" />
                </div>
                {phones?.[0] && (
                  <a className="h5" href={`tel:${phones?.[0].phone}`}>
                    {phones?.[0].phone}
                  </a>
                )}
              </div>

              <ModalForm
                toggle={
                  <Button className="-m-px" variant="white">
                    Записаться
                  </Button>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
